/*
 * Live cart-total badge swap.
 * Toggles `cart-qualified` on <body> whenever the customer's cart total
 * crosses the July badge threshold, so every product card flips between the
 * "Spend $X" and "unlocked" states without a page reload.
 *
 * The initial state is rendered server-side in theme.liquid (no flash);
 * this script only reconciles it after cart mutations.
 */
(function () {
  var THRESHOLD = window.JULY_BADGE_THRESHOLD || 10000; // cents
  var CART_RE = /\/cart\/(add|change|update|clear)/;

  function apply(totalCents) {
    document.body.classList.toggle('cart-qualified', totalCents >= THRESHOLD);
  }

  var pending = false;
  function refresh() {
    if (pending) return;
    pending = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { apply(cart.total_price); })
      .catch(function () {})
      .then(function () { pending = false; });
  }

  function schedule() { setTimeout(refresh, 60); }

  // Catch cart mutations made via fetch (Shopify AJAX API, most modern apps).
  if (window.fetch) {
    var _fetch = window.fetch;
    window.fetch = function (input) {
      var p = _fetch.apply(this, arguments);
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        if (CART_RE.test(url)) p.then(schedule, function () {});
      } catch (e) {}
      return p;
    };
  }

  // Catch cart mutations made via XHR (jQuery / Empire theme code).
  if (window.XMLHttpRequest) {
    var _open = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      try {
        if (CART_RE.test(url || '')) this.addEventListener('load', schedule);
      } catch (e) {}
      return _open.apply(this, arguments);
    };
  }

  // Common theme/app cart events as a belt-and-suspenders fallback.
  ['cart:updated', 'cart:refresh', 'cart:build', 'ajaxCart:afterCartLoad'].forEach(function (ev) {
    document.addEventListener(ev, schedule);
  });

  // Reconcile once on load in case the server-rendered state is stale.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }
})();
